import { ISensitiveSettings } from 'web-core-src';

export interface IWebCoreSensitiveSettings extends ISensitiveSettings {
    webSensitive: boolean;
}
